import axios from "axios";
import { APIAddress } from "constants/config";
import Joi from 'joi-browser';

export const schema = Joi.object().keys({
  logo: Joi.string().allow('').allow(null),  
  title: Joi.string().allow('').allow(null), 
  description: Joi.string().allow('').allow(null), 
  chineseTitle: Joi.string().allow('').allow(null), 
  chineseDescription: Joi.string().allow('').allow(null),
  schoolType: Joi.number().integer().allow(null),
  rating: Joi.string().allow('').allow(null), 
  totalNumberOfRatings: Joi.number().integer(),
  suitAgeLower: Joi.number().integer().allow(null),
  suitAgeUpper: Joi.number().integer().allow(null),
  openHours: Joi.string().allow('').allow(null), 
  address: Joi.string().allow('').allow(null), 
  suit_number: Joi.string().allow('').allow(null), 
  postcode: Joi.string().allow('').allow(null),   
  city: Joi.string().allow('').allow(null), 
  province: Joi.string().allow('').allow(null), 
  country: Joi.string().allow('').allow(null), 
  timezone: Joi.string().allow('').allow(null), 
  currency: Joi.string().allow('').allow(null),
  homepage: Joi.string().allow('').allow(null), 
  phone: Joi.string().allow('').allow(null),
  email: Joi.string().allow('').allow(null), 
  image: Joi.string().allow('').allow(null),
  numberOfViews: Joi.number().integer().allow(null),
  enable: Joi.boolean(),
  approval: Joi.number().integer(),
  remark: Joi.string().allow('').allow(null),
  ownerUser: Joi.number().integer(),
  tags: Joi.array().items(Joi.string()),
  categories: Joi.array().items(Joi.number().integer()),
});

/**
* PUT 
* Return the information of school.
**/
export default function updateSchoolDetail(schoolID, schoolDetail) {
	if (!schoolID) {
		throw "ERROR getSchoolDetail(): schoolID is missing";
	}
  
  let validateResult = Joi.validate(schoolDetail, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject)=>{
    axios.put(APIAddress, {
      'uri': `/u_school/${schoolID}/`, 
      'method': 'PUT', 
      'token': localStorage.getItem('token'),
      'data': JSON.stringify(schoolDetail),
    })
		.then((res)=>{
			let toReturn = res.data;
			resolve(toReturn);
		})
		.catch((err)=>{
			reject(err);
		});
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/updateSchoolDetail.js